import { withInstall } from '@vuesax-plus/utils'
import CardGroup from './src/card-group.vue'

export const VsCardGroup = withInstall(CardGroup)
export default VsCardGroup

export * from './src/card-group'
